import React, { useState } from 'react';
import Toggle from 'components/common/Toggle'
import CustomTickBox from 'components/common/CustomTickBox'
const SensorOption = (props) => {
    const { slideType, isStandbyAsUnOccupied, sensorFilterType, setLivefeedOptionsHandle, setLivefeedGlobalOptionsHandle } = props
    const [globalSetting, setGlobalSetting] = useState(false);
    return (
        <div className="gauge-grid-item">
            <div className="editor-container">
                <div className="header grid-item">SENSORS</div>
                {slideType !== "summary" &&
                    <React.Fragment>
                        <span className="editor-text grid-item grid-item__title"
                            data-tip={`Option to choose the number of available units either as one figure ("50") or two ("50/75").`}
                            data-for="floorplanOptionsTooltip"
                            style={{ whiteSpace: "normal" }}>
                            Sensors filtering  </span>
                        <div className="editor-text grid-item ">
                            <CustomTickBox
                                className="widget-label-setting"
                                onClick={() => {
                                    /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
                                    globalSetting === true && setGlobalSetting(false)
                                    setLivefeedOptionsHandle("sensorFilterType", "occupied-unOccupied")
                                }}
                                label="Show all units"
                                isActive={sensorFilterType === "occupied-unOccupied"}
                            />
                        </div>
                        <div className="editor-text grid-item ">
                            <CustomTickBox
                                className="widget-label-setting"
                                onClick={() => {
                                    /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
                                    globalSetting === true && setGlobalSetting(false)
                                    setLivefeedOptionsHandle("sensorFilterType", "unOccupied")
                                }}
                                label="Show available units only"
                                isActive={sensorFilterType === "unOccupied"}
                            />
                        </div>
                    </React.Fragment>
                }
                <div className="editor-text grid-item grid-item_divider-line">
                    <p>Treat standby sensors as</p>
                    <div
                        style={{ whiteSpace: "normal" }}
                        className="occupied-toggle"
                        onClick={() => {
                            /* if globalSetting is enabled, then when the sensorFilterType is modified, set setGlobalSetting to be false*/
                            globalSetting === true && setGlobalSetting(false)
                            setLivefeedOptionsHandle("treatStandbySensor", !isStandbyAsUnOccupied)
                        }}>
                        <div className="toggle-text"> Occupied</div>
                        <Toggle isActive={isStandbyAsUnOccupied} />
                        <div className="toggle-text"> Unoccupied</div>
                    </div>
                </div>
                <div className="editor-text grid-item global-toggle-item">
                    <div
                        data-for="floorplanOptionsTooltip"
                        style={{ whiteSpace: "normal" }}
                        data-tip="Apply&nbsp;this&nbsp;setting&nbsp;to&nbsp;all&nbsp;slides"
                        className="global-option-toggle"
                        onClick={() => {
                            setGlobalSetting(!globalSetting);
                            setLivefeedGlobalOptionsHandle({ sensorFilterType: sensorFilterType, isStandbyAsUnOccupied: isStandbyAsUnOccupied })
                        }}>
                        <div className="toggle-text">Apply to all slides</div>
                        <Toggle isActive={globalSetting} />
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SensorOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/SensorOption/index.jsx